export const TIMEOUT_NOTIFICATIONS = 'TIMEOUT_NOTIFICATIONS'
export const SEE_NOTIFICATIONS = 'SEE_NOTIFICATIONS'
export const HIDE_NOTIFICATIONS = 'HIDE_NOTIFICATIONS'

export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS'
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS'
export const FETCH_NOTIFICATIONS_ERROR = 'FETCH_NOTIFICATIONS_ERROR'

export const CONSUME_NOTIFICATION = 'CONSUME_NOTIFICATION'
export const CONSUME_NOTIFICATION_SUCCESS = 'CONSUME_NOTIFICATION_SUCCESS'
export const CONSUME_NOTIFICATION_ERROR = 'CONSUME_NOTIFICATION_ERROR'

export const FLIRT_POPUP = 'FLIRT_POPUP'
